import React, {FC, createContext, useContext, useEffect, useState} from 'react'
import i18n from '../../i18n'
import {WithChildren} from '../helpers'

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

type Props = {
  selectedLang: 'en' | 'fa' | 'ar' | 'tr'
}
const initialState: Props = {
  selectedLang: 'fa',
}

const setDocumentDirection = (lang: string) => {
  document.documentElement.lang = lang
  document.documentElement.dir = ['fa', 'ar'].includes(lang) ? 'rtl' : 'ltr'
}

function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  if (ls) {
    try {
      return JSON.parse(ls) as Props
    } catch (er) {
      console.error(er)
    }
  }
  return initialState
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({selectedLang: lang}))
  setDocumentDirection(lang)
  i18n.changeLanguage(lang)
  window.dispatchEvent(new CustomEvent('languageChanged', {detail: lang}))
}

const I18nContext = createContext<Props>(initialState)

const useLang = () => {
  return useContext(I18nContext).selectedLang
}

const MetronicI18nProvider: FC<WithChildren> = ({children}) => {
  const [lang, setLang] = useState<Props>(getConfig())

  useEffect(() => {
    setDocumentDirection(lang.selectedLang)

    const handleLanguageChange = (event: Event) => {
      const selectedLang = (event as CustomEvent<Props['selectedLang']>).detail
      setLang({selectedLang})
    }

    window.addEventListener('languageChanged', handleLanguageChange)

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange)
    }
  }, [lang.selectedLang])

  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>
}

export {MetronicI18nProvider, useLang}
